module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUdwTDIyMjExMTIyMjIyMjIyMjAwMDAwMDIyMjAwMDIyMjMzMzMzM0teFo4AAAAMdFJOUwDAQ/CZYxAw2yCAryHXVhoAAACDSURBVCjPY2CgHWALcU1AEQg+c8YUmc90BggUkAQ4QAINSAI1IIHjSAI6IIFD+ASYQQIGSAJcIIEFyPb6nDlzBMVhrD0HA0j1nJISsufYom3OnDm8FS7E6XMGDI5MgAoon4ECIwif3QYmcLgALMByBg4cwAKMCAEB7AIsgnDgQKM4BACRL1VPXYEt+wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/my-profile.png
// module id = 1119
// module chunks = 0